<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="main-debit-list-popup" *ngIf="!showLoader && hok">
    <h1 class="ellipsis-one-line">{{ hok.merchantName }}</h1>
    <div class="info">
        <span class="adress" *ngIf="address">{{ address }}</span>
        <span class="phone" *ngIf="hok.merchantPhone"
            ><a (click)="clickPhone(hok.merchantPhone)" [ngClass]="{ mobile: !uiHelperSrv.IsMobile() }">{{
                hok.merchantPhone
            }}</a></span
        >
    </div>
    <div class="deal-info">
        <ul>
            <li *ngIf="txnMethod">
                <span class="title">אופן הביצוע: </span><span class="ellipsis-one-line">{{ txnMethod }}</span>
            </li>
            <li *ngIf="planName">
                <span class="title">סוג העסקה: </span><span class="ellipsis-one-line">{{ planName }}</span>
            </li>

            <li *ngIf="hok.categoryDescription">
                <span class="title ellipsis-one-line">ענף פעילות: </span
                ><span class="ellipsis-one-line">{{ hok.categoryDescription }}</span>
            </li>
        </ul>
    </div>
    <div class="last-obligations">
        <h2>
            {{
                hok.hokHistoryDetails.hokTransDetailsList?.slice(0, 12).length == 0
                    ? 'לא מצאנו חיובים אחרונים'
                    : 'חיובים אחרונים'
            }}
        </h2>
        <ul class="scolling">
            <li *ngFor="let hokTransDetails of hok.hokHistoryDetails.hokTransDetailsList?.slice(0, 12)">
                <span class="sum-wrapper">
                    <span class="date">({{ hokTransDetails.purchaseDate | date: 'dd.MM.yyyy' }})</span
                    ><span class="sum">{{ hokTransDetails.paymentAmount | maxCurrency: 'ILS' }}</span></span
                >
            </li>
        </ul>
    </div>
    <div class="status">
        <span>סטטוס: {{ status }}</span>
    </div>
    <div *ngIf="contents && status == 'בוטל'">
        <h3 class="textCenter">{{ contents.mainDebitList.textAboutFailedStatus }}</h3>
    </div>
    <div class="error">
        <span *ngIf="rcCancel == 11">כבר קיימת בקשה</span>
    </div>
    <div class="button-wrapper" *ngIf="hok.isPersonalHok">
        <div [ngSwitch]="hok.status">
            <ng-container *ngSwitchCase="1">
                <a (click)="next('cancel')" *ngIf="rcCancel != 11" class="brand-button aqua-button"
                    ><span>למידע נוסף וביטול הוראת הקבע</span></a
                >
                <div class="error">
                    <span *ngIf="rcCancel == 10">התחלת טיפול על עסקה זו</span>
                    <span *ngIf="rcCancel == 10 && cbkId != 0"> מספר הפניה: {{ cbkId }}</span>
                </div>
            </ng-container>

            <a *ngSwitchCase="2" (click)="next('release')" class="brand-button aqua-button"
                ><span>הפשרת הוראת קבע</span></a
            >
            <div *ngSwitchDefault></div>
        </div>
    </div>
</div>
<max-loader *ngIf="showLoader"></max-loader>
